import { useI18n } from 'vue-i18n'
import type { RouteName } from '@/router/routes'
import { isLocale, type Locale } from '@/router/locales'
import { localizedPath as buildLocalizedPath, type RouteParams } from '@/router/i18nPath'
import { getFallbackLocale, normalizeLocale } from '@/utils/locale'

export function useI18nRoute() {
  const { locale } = useI18n()

  function resolveLocale(): Locale {
    const resolvedLocale = normalizeLocale(locale.value)
    return isLocale(resolvedLocale) ? resolvedLocale : getFallbackLocale()
  }

  function localizedPath(name: RouteName, params?: RouteParams, localeOverride?: Locale) {
    return buildLocalizedPath(name, params, localeOverride ?? resolveLocale())
  }

  return { localizedPath }
}
